module.exports = __webpack_public_path__ + "static/media/playlist-large.adecd885.svg";